import {
  APIPersonalAutoApplicationFormDriver,
  APIBinderQuoteData,
  APIQuoteDriver,
  APIQuoteVehicleDriver,
  APIBinderInsuranceData,
} from 'types/api.types';

export const countPrincipalDrivers = (
  quoteData: APIBinderQuoteData,
  driver:
    | APIQuoteVehicleDriver
    | APIPersonalAutoApplicationFormDriver
    | APIQuoteDriver,
): number => {
  let principalDriverCount = 0;

  if (!quoteData?.vehicles) return principalDriverCount;

  quoteData.vehicles.forEach((vehicle) => {
    vehicle.drivers.forEach((vDriver) => {
      if (vDriver.name === driver.name && vDriver.is_principal) {
        principalDriverCount++;
      }
    });
  });

  return principalDriverCount;
};

interface ProcessedValidation {
  isValid: boolean;
  message?: string | undefined;
}

export function getInsuranceSourceLabel(
  source: APIBinderInsuranceData['source'] | undefined,
): string {
  switch (source?.toLowerCase()) {
    case 'dash':
      return 'Dash';
    case 'autoplus':
      return 'AutoPlus';
    default:
      return '';
  }
}

export const processValidation = (
  validation?: Validation,
): ProcessedValidation => {
  if (!validation) {
    return {
      isValid: true,
      message: undefined,
    };
  }
  const isValid = validation.validation_outcome === 'pass';

  return {
    isValid,
    message: isValid ? undefined : validation.validation_message,
  };
};

export const validateFailedObjects = (
  index: number,
  validation?: Validation,
): boolean => {
  if (!validation?.failed_objects) return true;

  return !validation.failed_objects.includes(index + 1);
};

export const formatPayout = (payout: any): string => {
  if (!payout || payout === 0) return '$0';
  const numValue =
    typeof payout === 'string'
      ? parseFloat(payout.replace(/[$,]/g, ''))
      : payout;
  return isNaN(numValue) ? '$0' : `$${numValue.toLocaleString()}`;
};

// Format fault status
export const formatFault = (fault: any): string => {
  if (typeof fault === 'boolean') return fault ? 'At Fault' : 'Not At Fault';
  if (typeof fault === 'string') {
    const normalized = fault.toLowerCase();
    if (normalized.includes('fault') && !normalized.includes('not'))
      return 'At Fault';
    if (normalized.includes('not') || normalized.includes('no'))
      return 'Not At Fault';
    return fault;
  }
  return fault?.toString() || 'N/A';
};
